let initState = {
  cardId: '',
  sonCardId: '',
  searchBox: 1,
  ageConfine: { ageMax: 0, ageMin: 0, isOpen: 0 },
  gsdDefault: { btn: false, province: '', provinceStr: '', city: '', cityStr: '' },
  selectCard: {}
}

let cloneDeep = data => {
  //copy一份数据
  return JSON.parse(JSON.stringify(data))
}
const state = cloneDeep(initState)
const mutations = {
  SET_CARDID: (state, cardId) => {
    state.cardId = cardId
  },
  SET_SERARCHBOX: (state, searchBox) => {
    state.searchBox = searchBox
  },
  SET_AGECONFINE: (state, ageConfine) => {
    state.ageConfine = ageConfine
  },
  SET_GSDDEFAULT: (state, gsdDefault) => {
    state.gsdDefault = gsdDefault
  },
  SET_SONCARDID: (state, sonCardId) => {
    state.sonCardId = sonCardId
  },
  SET_SELECTCARD: (state, selectCard) => {
    state.selectCard = selectCard
  }
}
const actions = {
  setCard({ commit, dispatch }, data) {
    const { card_type, cardModule } = data
    commit(`SET_SELECTCARD`, data)

    commit(`SET_CARDID`, card_type)
    dispatch(`setCardModule`, cardModule)
  },
  setCardModule({ commit, rootGetters }, data) {
    const { searchBox, ageConfine, cityCtrl } = data,
      { templateId } = rootGetters
    commit(`SET_SERARCHBOX`, searchBox) //隐藏搜索号码
    commit(`SET_AGECONFINE`, ageConfine)
    if (cityCtrl.length == 1 && cityCtrl[0].children.length == 1 && templateId && templateId != 5) {
      let { provinceId, provinceName, children } = cityCtrl[0]
      commit(`SET_GSDDEFAULT`, { btn: true, province: provinceId, provinceStr: provinceName, city: children[0].cityId, cityStr: children[0].cityName })
    } else {
      commit(`SET_GSDDEFAULT`, { btn: false, province: '', provinceStr: '', city: '', cityStr: '' })
    }
  },

  setSonCard({ commit }, data) {
    commit(`SET_SONCARDID`, data)
  },
  
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
